import React from 'react';
import { content } from '../data/content';
import { motion } from 'framer-motion';
import { CircleCheck, ArrowRight } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div>
            <div className="mb-12">
              <h2 className="text-4xl lg:text-5xl mb-6">{content.howItWorks.title}</h2>
              <p className="text-navy/60 text-lg">{content.howItWorks.subtitle}</p>
              {/* <button className="mt-6 flex items-center gap-2 text-primary font-bold border-b border-primary/20 pb-1 hover:border-primary transition-all">
                REQUEST A CONSULTATION <ArrowRight size={18} />
              </button> */}
            </div>

            <div className="space-y-8">
              {content.howItWorks.steps.map((step, idx) => (
                <motion.div 
                  key={idx}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  className={`p-6 rounded-2xl transition-all border ${
                    idx === 1 ? 'bg-primary text-white shadow-xl shadow-primary/20 scale-105 border-transparent' : 'bg-white text-navy border-navy/5 shadow-sm'
                  }`}
                >
                  <div className="flex items-start gap-6">
                    <span className={`text-2xl font-bold ${idx === 1 ? 'text-white/40' : 'text-primary'}`}>
                      {step.number}
                    </span>
                    <div>
                      <h4 className="text-xl font-bold mb-2">{step.title}</h4>
                      <p className={`text-sm ${idx === 1 ? 'text-white/70' : 'text-navy/60'}`}>
                        {step.description}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            className="relative rounded-[3rem] overflow-hidden aspect-[4/5] shadow-2xl"
          >
            <img 
              src="/how-it-works.jpg" 
              alt="Team collaboration workflow" 
              className="w-full h-full object-cover"
            />
            {/* Overlay element */}
            <div className="absolute top-10 right-10 bg-white/90 backdrop-blur-md p-6 rounded-3xl border border-white/20 shadow-xl max-w-[240px]">
              <div className="w-12 h-12 bg-accent-teal/20 rounded-full flex items-center justify-center text-accent-teal mb-4">
                <CircleCheck size={28} />
              </div>
              <h5 className="font-bold text-navy mb-2">Verified Experts</h5>
              <p className="text-xs text-navy/60 leading-relaxed">
                All teams are vetted for technical excellence and cultural fit.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
